import React, { useState, useEffect } from 'react'
import PreLoader from '../../../../core/common/preLoader';
import useFetch from '../../../../hooks/useFetch';
import { Link } from 'react-router';
import { all_routes } from '../../../router/all_routes'
import CopyRightInfo from '../../../../core/common/copyRightInfo';
import CollapseHeader from '../../../../core/common/collapse-header/collapse-header';
import AcademicTreeView from './academicTreeView';
import { Curriculum } from '../../../../types/dataModel';
import { API } from '../../../../common/Constants';
import { getAPIHeaders } from '../../../../common/Utils';
import RelationshipVisualizer from '../relationship-diagram/RelationshipVisualizer';

const AcademicLens = () => {
    const { isLoading, data, callFetch } = useFetch();
    const [curriculumns, setCurriculums] = useState<Curriculum[]>([]);
    const [courseOptions, setCourseOptions] = useState<any[]>([])
    const [subjectOptions, setSubjectOptions] = useState<any[]>([])
    const [syllabusOptions, setSyllabusOptions] = useState<any[]>([])
    const [selectedCurriculumId, setSelectedCurriculumId] = useState<number | null>(null);
    const [viewMode, setViewMode] = useState<'tree' | 'relationship'>('tree');

    useEffect(() => {
        fetch()
        fetchCourses()
        fetchSubjects()
        fetchSyllabus()
    }, []);
    
    const fetch = () => {
        callFetch(API.ACADEMIC_LENS,
          'GET',
          getAPIHeaders(),
          null,
          null
      ).then((res)=>{
        setCurriculums(res)
      }).catch((err) => {});
    }
    
    
    const fetchCourses = () => {
      callFetch(API.COURSE_SEARCH,
        'GET',
        getAPIHeaders(),
        null,
        null
      ).then((res) => {
        setCourseOptions(res?.map((item: any) => (
          {
            value: item?.code,
            label: item?.title,
          }
        )))
      }).catch((err) => {});
    }

    const fetchSubjects = () => {
      callFetch(API.SUBJECT_SEARCH,
        'GET',
        getAPIHeaders(),
        null,
        null
      ).then((res) => {
        setSubjectOptions(res?.map((item: any) => (
          {
            value: item?.code,
            label: item?.title,
          }
        )))
      }).catch((err) => {});
    }


    const fetchSyllabus = () => {
      callFetch(API.SYLLABUS_SEARCH,
        'GET',
        getAPIHeaders(),
        null,
        null
      ).then((res) => {
        setSyllabusOptions(res?.map((item: any) => (
          {
            value: item?.code,
            label: item?.title,
          }
        )))
      }).catch((err) => {});
    }
      
    return (
        <>
          <PreLoader showLoader={isLoading} />
          {/* Page Wrapper */}
          <div className="page-wrapper">
            <div className="content">
              {/* Breadcrumb */}
              <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                <div className="my-auto mb-2">
                  <h2 className="mb-1">Academic Lens</h2>
                  <nav>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={all_routes.adminDashboard}>
                          <i className="ti ti-smart-home" />
                        </Link>
                      </li>
                      <li className="breadcrumb-item">Academics</li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Academic Lens
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                  <div className="d-flex mb-2 right-content gap-3">
                    <button
                      className="btn btn-primary d-flex align-items-center"
                      onClick={(e)=>{
                        e.preventDefault()
                        fetch()
                      }}
                    >
                      <i className="ti ti-refresh me-2"
                      />
                      Refresh
                    </button>
                  </div>
                  <div className="head-icons ms-2">
                    <CollapseHeader />
                  </div>
                </div>
              </div>
              {/* /Breadcrumb */}
              {/* Performance Indicator list */}
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Academics Overview</h5>
                  <div className="d-flex align-items-center">
                    <div className="view-toggle-buttons me-3">
                      <div className="btn-group" role="group" aria-label="View Mode Selection">
                        <button 
                          type="button" 
                          className={`btn ${viewMode === 'tree' ? 'btn-primary' : 'btn-outline-primary'}`}
                          onClick={() => setViewMode('tree')}
                          aria-pressed={viewMode === 'tree'}
                          aria-label="Tree View"
                        >
                          <i className="ti ti-tree me-1" aria-hidden="true"></i> Tree View
                        </button>
                        <button 
                          type="button" 
                          className={`btn ${viewMode === 'relationship' ? 'btn-primary' : 'btn-outline-primary'}`}
                          onClick={() => setViewMode('relationship')}
                          aria-pressed={viewMode === 'relationship'}
                          aria-label="Relationship View"
                        >
                          <i className="ti ti-hierarchy-2 me-1" aria-hidden="true"></i> Relationship View
                        </button>
                      </div>
                    </div>
                    
                    {viewMode === 'relationship' && (
                      <div className="curriculum-selector">
                        <select 
                          className="form-select form-select-sm"
                          onChange={(e) => setSelectedCurriculumId(e.target.value ? Number(e.target.value) : null)}
                          value={selectedCurriculumId || ''}
                          aria-label="Select curriculum to visualize"
                          aria-describedby="curriculum-selector-help"
                        >
                          <option value="">All Curriculum</option>
                          {curriculumns.map((curriculum) => (
                            <option key={curriculum.id} value={curriculum.id}>
                              {curriculum.title}
                            </option>
                          ))}
                        </select>
                        <small id="curriculum-selector-help" className="visually-hidden">
                          Choose a specific curriculum to focus on, or select 'All Curriculum' to view everything
                        </small>
                      </div>
                    )}
                  </div>
                </div>
                <div className="card-body p-10">
                {viewMode === 'tree' ? (
                  <AcademicTreeView 
                    refresh={fetch} 
                    data={curriculumns} 
                    courseOptions={courseOptions} 
                    subjectOptions={subjectOptions} 
                    syllabusOptions={syllabusOptions} 
                  />
                ) : (
                  <RelationshipVisualizer
                    curriculumId={selectedCurriculumId || undefined}
                    showFullHierarchy={!selectedCurriculumId}
                  />
                )}
                </div>
              </div>
              {/* /Performance Indicator list */}
            </div>
            <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
              <CopyRightInfo/>
            </div>
          </div>
          {/* /Page Wrapper */}

        </>
    
    
      )
}

export default AcademicLens